import { IconButton as e } from "../icon-button/IconButton.js";
import { XCloseIcon as t } from "../icons/XCloseIcon.js";
import { PopoverGroup as n } from "../popover/PopoverGroup.js";
import { OverlayFooter as r } from "./OverlayFooter.js";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import o from "clsx";
import { useEffect as s, useRef as c, useState as l } from "react";
//#region src/components/overlays/OverlayFrame.tsx
function u({ heading: u, description: d, children: f, footerConfig: p, onClose: m, onCancel: h, pending: g, error: _, closeConfig: v, compact: y = !1, hideHeader: b = !1, bottom: x = !1, confirm: S = !1 }) {
	let C = c(null), w = c(null), [T, E] = l(!1);
	return s(() => {
		let e = C.current;
		if (!e) return;
		let t = () => {
			E(e.scrollTop > 0);
		};
		return t(), e.addEventListener("scroll", t, { passive: !0 }), () => {
			e.removeEventListener("scroll", t);
		};
	}, []), /* @__PURE__ */ a(n, { children: [
		b ? /* @__PURE__ */ a("div", {
			className: "pf:sr-only",
			children: [u, d]
		}) : /* @__PURE__ */ a("header", {
			className: o("pf:flex pf:shrink-0 pf:border-0 pf:border-b-[0.5px] pf:border-solid", T ? "pf:border-soft-pearl-300" : "pf:border-transparent", y ? "pf:items-center pf:gap-md" : "pf:items-start pf:gap-xl", y ? "pf:ps-xl pf:pe-md pf:pt-lg pf:pb-xs" : x ? "pf:ps-3xl pf:pe-xl pf:pt-lg pf:pb-xl" : "pf:ps-3xl pf:pe-xl pf:pt-2xl pf:pb-xl"),
			children: [/* @__PURE__ */ a("div", {
				className: o("pf:min-w-0 pf:flex-1", !y && "pf:pt-xs"),
				children: [u, d]
			}), !S && v?.visible !== !1 && /* @__PURE__ */ i(e, {
				label: v?.label ?? "Close",
				tooltip: !1,
				size: y ? "xs" : "sm",
				disabled: g,
				onClick: m,
				children: /* @__PURE__ */ i(t, {})
			})]
		}),
		!S && /* @__PURE__ */ i("div", {
			ref: C,
			"data-overlay-body": !0,
			className: o("pf:min-h-0 pf:min-w-0 pf:flex-1 pf:overflow-y-auto pf:overscroll-contain pf:wrap-anywhere", y ? b ? "pf:p-md" : "pf:px-xl pf:pt-xs pf:pb-lg" : "pf:px-3xl pf:pt-xs pf:pb-xl"),
			children: /* @__PURE__ */ i("div", {
				ref: w,
				children: f
			})
		}),
		_ && /* @__PURE__ */ i("p", {
			role: "alert",
			className: "pf:m-0 pf:px-3xl pf:py-md pf:text-red-800",
			children: _
		}),
		p && /* @__PURE__ */ i(r, {
			config: p,
			onCancel: h,
			pending: g,
			compact: y,
			divider: y || T
		})
	] });
}
//#endregion
export { u as OverlayFrame };
